module.exports = __webpack_public_path__ + "static/media/taimalishan.47b6fcf4.webp";